<div fxLayout="row" fxLayout.xs="column" style="height: 320px;">
    <div fxFlex="33.33%" style="padding: 0 10px 0 10px;">
    </div>
    <div fxFlex="33.33%" style="padding: 0 10px 0 10px; overflow: auto;">
        <div style="padding: 10px;"><strong>Student Infos:</strong></div>
        <table>
            <tbody>
                <tr>
                    <td style="padding: 8px;">Belongs:</td>
                    <td style="padding: 8px;">XOF {{rowInfos['belongs']}}</td>
                </tr>
                <tr>
                    <td style="padding: 8px;">Institution:</td>
                    <td style="padding: 8px;" matTooltip="{{ rowInfos['student_institution'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{rowInfos['student_institution']}}</td>
                </tr>
                <tr>
                    <td style="padding: 8px;">Study:</td>
                    <td style="padding: 8px;" matTooltip="{{ rowInfos['student_study'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{rowInfos['student_study']}}</td>
                </tr>
                <tr>
                    <td style="padding: 8px;">Can be notified:</td>
                    <td style="padding: 8px;">{{rowInfos['can_be_notified']}}</td>
                </tr>
                <tr>
                    <td style="padding: 8px;">Id Subscription:</td>
                    <td style="padding: 8px;">{{rowInfos['id_subscription']}}</td>
                </tr>
                <tr>
                    <td style="padding: 8px;">Downloaded contents:</td>
                    <td style="padding: 8px;">{{rowInfos['nb_content_student']}}</td>
                </tr>
                <tr>
                    <td style="padding: 8px;">Total Content:</td>
                    <td style="padding: 8px;">{{rowInfos['nb_content']}}</td>
                </tr>
                <tr>
                    <td style="padding: 8px;">Current Subscription:</td>
                    <td style="padding: 8px;" matTooltip="{{ rowInfos['subscription_name'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{rowInfos['subscription_name']}}</td>
                </tr>
                <tr>
                    <td style="padding: 8px;">Expiration Date:</td>
                    <td style="padding: 8px;">{{rowInfos['sub_expiration_date']}}</td>
                </tr>
                <tr>
                    <td style="padding: 8px;">Device Type:</td>
                    <td style="padding: 8px;">{{rowInfos['device_type']}}</td>
                </tr>
                <tr>
                    <td style="padding: 8px;">Created Date:</td>
                    <td style="padding: 8px;">{{rowInfos['created_date']}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div fxFlex="33.33%" style="padding: 0 10px 0 10px; overflow: auto;">
        <div fxLayout="row" style="padding: 10px" class="element-style">
            <div class="label-style" fxFlex="30%">Give Free Sub.</div>
            <div fxFlex="55%">
                <mat-select placeholder="Product" [formControl]="promotionControl">
                    <mat-option [value]="element['id']" *ngFor="let element of promotionData; let i = index">{{element['product_name']}}: {{element['promo_name']}} ({{element['duration']}} Months)</mat-option>
                </mat-select>
            </div>
            <div fxFlex="15%">
                <button class="separator" type="button" class="button-validate-small" (click)="createPromotion()" >Create</button>
            </div>
        </div>
        <table>
            <thead>
            <tr>
                <th><div class="column-name">Id Subs</div></th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'promotion_name', 'string')"></mat-icon>
                    <div class="column-name">Promotion</div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'product_name', 'string')"></mat-icon>
                    <div class="column-name">Product</div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'activation_date', 'date')"></mat-icon>
                    <div class="column-name">Active Date</div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'expiration_date', 'date')"></mat-icon>
                    <div class="column-name">Expire Date</div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'active', 'boolean')"></mat-icon>
                    <div class="column-name">Active</div>
                </th>
            </tr>
            </thead>
            <tbody *ngFor="let row of showedRows; let i = index">
                <tr>
                    <td>{{row['id_subscription']}}</td>
                    <td matTooltip="{{ row['promotion_name'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['promotion_name'] }}</td>
                    <td matTooltip="{{ row['product_name'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['product_name'] }}</td>
                    <td>{{ row['activation_date'] }}</td>
                    <td>{{ row['expiration_date'] }}</td>
                    <td>{{ row['active'] }}</td>
                </tr>
            </tbody>
            <tbody *ngIf="showedRows.length === 0">
                <tr ><td colspan="7" style="text-align: center;">No matching records found</td></tr>
            </tbody>
        </table>
    </div>
</div>

